var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-keep-reading__wrapper"},[_c('section-title',{staticClass:"article-keep-reading__title"},[_vm._v("\n    Keep Reading\n  ")]),_vm._v(" "),_c('article-bullet-list',{attrs:{"articles":_vm.articles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }